import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "station-connected-domains-seperator mt-5 d-none d-md-block" }
const _hoisted_2 = {
  style: {"color":"var(--primary-blue)"},
  width: "1140",
  height: "36"
}

import { computed, onMounted, nextTick, watch } from "vue";
import Collapsible from "@/collapsible/collapsible.js";
import DomainInfo from "./DomainInfo.vue";
import ConnectedDomainInfo from "./ConnectedDomainInfo.vue";

// Define types for the props
interface DomainsSection {
  data: Record<string, any>;
  stationData: Record<string, any>;
  descriptionText: string;
  season: string;
}

// Props

export default /*@__PURE__*/_defineComponent({
  __name: 'DomainsSection',
  props: {
    data: {},
    stationData: {},
    descriptionText: {},
    season: {}
  },
  setup(__props: any) {

const props = __props;

// Computed property for content
const content = computed<Record<string, string>>(() => {
  return window.content || {};
});

// Initialize collapsible elements
const initializeCollapsibleElements = () => {
  const collapsibles = document
    .querySelector("#station-wrapper")
    ?.querySelectorAll(".collapse");
  collapsibles &&
    Array.from(collapsibles).forEach((div) => {
      new Collapsible(div).init();
    });
};

// Lifecycle Hook
onMounted(() => {
  initializeCollapsibleElements();
});

// Re-initialize collapsibles after the season-dependent DOM is redrawn.
watch(
  () => props.season,
  async () => {
    await nextTick();
    initializeCollapsibleElements();
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(), _createElementBlock("svg", _hoisted_2, _cache[0] || (_cache[0] = [
        _createElementVNode("use", { href: "#___icon___section-separator" }, null, -1)
      ])))
    ]),
    (_openBlock(), _createBlock(DomainInfo, {
      key: `domain-info-${_ctx.season}`,
      data: _ctx.data,
      stationData: _ctx.stationData,
      descriptionText: _ctx.descriptionText,
      season: _ctx.season,
      content: content.value
    }, null, 8, ["data", "stationData", "descriptionText", "season", "content"])),
    (_openBlock(), _createBlock(ConnectedDomainInfo, {
      key: `connected-domain-info-${_ctx.season}`,
      data: _ctx.data,
      stationData: _ctx.stationData,
      season: _ctx.season,
      content: content.value
    }, null, 8, ["data", "stationData", "season", "content"]))
  ]))
}
}

})